import React, { useEffect, useState, useRef } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import apiConfig from "../apiConfig";

const AgentEdit = ({ match }) => {
  const Id = match.params._id;
  let history = useHistory();

  const token = localStorage.getItem("jwtToken");
  const decodedToken = token ? jwt_decode(token) : null;
  const userInfo = decodedToken;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getSummary();
  }, []);

  const getSummary = () => {
    setLoading(true);
    setError(null);
    fetch(`${apiConfig.baseURL}/api/agent/affDepoWtihReport?user_id=${Id}`, {
      method: "GET",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch data");
        return res.json();
      })
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load data. Please try again.");
        setLoading(false);
      });
  };

  const cards = data
    ? [

        {
          label: "Monthly Deposit",
          value: data.monthly_deposit_amount,
          icon: "calendar_today",
          color: "#10b981",
          bg: "#ecfdf5",
          border: "#a7f3d0",
          href : `#`
        },
        {
          label: "Monthly Withdraw",
          value: data.monthly_withdraw_amount,
          icon: "money_off",
          color: "#dc2626",
          bg: "#fef2f2",
          border: "#fecaca",
          href : `#`
        },
        {
          label: "Agent User Balance",
          value: data.total_agent_user_balance,
          icon: "account_balance_wallet",
          color: "#f59e0b",
          bg: "#fffbeb",
          border: "#fde68a",
          href : `#`
        },
        {
          label: "Agent User Count",
          value: data.total_agent_user_count,
          icon: "group",
          color: "#0ea5e9",
          bg: "#f0f9ff",
          border: "#bae6fd",
          isCount: true,
          href : `/reffered-list?userId=${Id}`
        },
     
        {
          label: "Monthly Deposit Bonus",
          value: data.monthly_deposit_bonus,
          icon: "card_giftcard",
          color: "#f97316",
          bg: "#fff7ed",
          border: "#fed7aa",
          href : `#`
        },
        {
          label: "Monthly Deposit Users",
          value: data.monthly_deposit_users,
          icon: "how_to_reg",
          color: "#6366f1",
          bg: "#eef2ff",
          border: "#c7d2fe",
          isCount: true,
          href : `#`
        },
 
      ]
    : [];

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />
 
      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">

              {/* Card Header */}
              <div className="card-header d-flex align-items-center justify-content-between">
                <h4 className="card-title mb-0">
                  <span style={{ fontWeight: "800" }}>{Id} : </span>
                  Master Agent Wallet Summary
                </h4>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={getSummary}
                  disabled={loading}
                >
                  <i className="material-icons" style={{ fontSize: "16px", verticalAlign: "middle" }}>
                    refresh
                  </i>{" "}
                  Refresh
                </button>
              </div>

              <div className="card-body">

                {/* Loading state */}
                {loading && (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Loading summary...</p>
                  </div>
                )}

                {/* Error state */}
                {error && !loading && (
                  <div className="alert alert-danger" role="alert">
                    <i className="material-icons" style={{ fontSize: "16px", verticalAlign: "middle" }}>
                      error
                    </i>{" "}
                    {error}
                  </div>
                )}

                {/* Summary Cards Grid */}
                {!loading && !error && data && (
                  <div className="row g-3">
                    {cards.map((card, index) => (
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6" key={index}>
                        <div
                          style={{
                            background: card.bg,
                            border: `1px solid ${card.border}`,
                            borderRadius: "12px",
                            padding: "18px 20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                            height: "100%",
                          }}
                        >
                       <Link to={card.href} style={{ textDecoration: "none", color: "inherit" }}> 
                          {/* Icon */}
                          <div
                            style={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "10px",
                              background: card.color + "20",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <i
                              className="material-icons"
                              style={{ color: card.color, fontSize: "20px" }}
                            >
                              {card.icon}
                            </i>
                          </div>

                          {/* Text */}
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                color: "#888",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                marginBottom: "4px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {card.label}
                            </div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: "800",
                                color: card.color,
                                lineHeight: 1.2,
                              }}
                            >
                              {card.isCount
                                ? card.value.toLocaleString()
                                : "৳ " + Number(card.value).toLocaleString("en-BD", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                            </div>
                          </div>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AgentEdit;
